import { atom } from "recoil";

export const seasonRailcardsDefaultState = {
  railcards: [],
  hasCustomerRailcard1617Saver: false,
};

export const seasonRailcardsState = atom({
  key: "seasonRailcardsState",
  default: seasonRailcardsDefaultState
});
